import reducer from "./reducers";
export { default as bookingActions } from "./actions";

export default reducer;